import axios, { AxiosHeaders } from 'axios'
import { DataTableFilterMeta, SortOrder } from 'primereact/datatable'
import { useUser } from './useUser'

export interface LazyState {
  first: number
  rows: number
  page: number
  sortField: string | undefined
  sortOrder: SortOrder | undefined
  filters: DataTableFilterMeta
}

export default function useWbapiInstance() {
  const { user: fbUser } = useUser()
  const wbapi = import.meta.env.VITE_WBAPI
  const api = axios.create({
    baseURL: wbapi,
    withCredentials: true,
  })

  api.interceptors.request.use(async (request) => {
    const token = await fbUser?.getIdToken()

    if (token) {
      request.headers = AxiosHeaders.from({ Authorization: `Bearer ${token}`, ...request.headers })
    }

    request.headers = request.headers || {}
    request.headers['X-USER-EMAIL'] = fbUser?.email || ''
    return request
  })

  api.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      console.error(`Error making request`, error)

      //checks if we have a custom error message from the API
      error.message = error.response?.data?.message ?? error.message
      return Promise.reject(error)
    }
  )

  return { api }
}
